// laneLabel — the display word a lane chip renders for a cookpit lane code.
//
// The course-word mapping (A0 → "Alert", S1–S3 → "Starter", M1–M3 → "Main",
// D1–D3 → "Dessert", raw code otherwise) lives in `@cookchow/shared` as
// `laneCourse`, so the web chips and the function's computed-hotspot text
// share one source of truth and neither leaks a raw lane code.
//
// Display only: lane-keyed logic (classifier, tick ordering) keeps using the
// original codes; this is purely what the lane chip renders.

import { laneCourse } from '@cookchow/shared';
import { theme } from '../theme';
import type { ChipStyle } from './Chip';

export function laneLabel(lane: string): string {
  return laneCourse(lane);
}

// The colour a lane chip carries, by course (Alert red, Starter light blue,
// Main gold, Dessert teal). Returns undefined for an unrecognised lane so
// the chip falls back to the neutral 'lane' variant style.
export function laneTone(lane: string): ChipStyle | undefined {
  switch (lane[0]?.toUpperCase()) {
    case 'A':
      return theme.lane.alert;
    case 'S':
      return theme.lane.starter;
    case 'M':
      return theme.lane.main;
    case 'D':
      return theme.lane.dessert;
    default:
      return undefined;
  }
}
